module.exports = __webpack_public_path__ + "img/image-1.71928d6a.jpg";